import { queryOptions } from '@tanstack/react-query';
import { privateClient } from '../axiosClients/axiosClients';

export async function getSiteOwner(params) {
  const response = await privateClient.get(
    `/siteOwner?pecrId=${params.pecrId}&siteId=${params.siteId}`
  );
  return response.data;
}

export function createGetSiteOwnerOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['getSiteOwner', params],
    queryFn: () => getSiteOwner(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export async function getSiteOwnerDetails(params) {
  const response = await privateClient.get(
    `/siteOwnerDetails?pecrId=${params.pecrId}&siteId=${params.siteId}`
  );
  return response.data;
}

export function createGetSiteOwnerDetailsOptions(params, options) {
  return queryOptions({
    ...options,
    queryKey: ['getSiteOwnerDetails', params],
    queryFn: () => getSiteOwnerDetails(params),
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
